module.exports = __webpack_public_path__ + "img/679.498ffa27.jpg";